module.exports = __webpack_public_path__ + "static/event3-c729126b20b1c8a6e2ea14d2e6a76aee.jpeg";